/**
 * WordPress dependencies
 */
import { Button, __experimentalHStack as HStack, SelectControl } from '@wordpress/components';
import { createInterpolateElement, memo } from '@wordpress/element';
import { sprintf, __, _x } from '@wordpress/i18n';
import { chevronRight, chevronLeft } from '@wordpress/icons';

/**
 * Internal dependencies
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Pagination = memo(function Pagination({
  view,
  onChangeView,
  paginationInfo: {
    totalItems = 0,
    totalPages
  }
}) {
  var _view$page;
  if (!totalItems || !totalPages) {
    return null;
  }
  const currentPage = (_view$page = view.page) !== null && _view$page !== void 0 ? _view$page : 1;
  return !!totalItems && totalPages !== 1 && /*#__PURE__*/_jsxs(HStack, {
    expanded: false,
    spacing: 6,
    justify: "end",
    className: "dataviews-pagination",
    children: [/*#__PURE__*/_jsx(HStack, {
      justify: "flex-start",
      expanded: false,
      spacing: 2,
      className: "dataviews-pagination__page-selection",
      children: createInterpolateElement(sprintf(
      // translators: %s: Total number of pages.
      _x('Page <CurrentPageControl /> of %s', 'paging'), totalPages), {
        CurrentPageControl: /*#__PURE__*/_jsx(SelectControl, {
          "aria-label": __('Current page'),
          value: view.page?.toString(),
          options: Array.from(Array(totalPages)).map((_, i) => {
            const page = i + 1;
            return {
              value: page.toString(),
              label: page.toString()
            };
          }),
          onChange: newValue => {
            onChangeView({
              ...view,
              page: +newValue
            });
          },
          size: "compact",
          __nextHasNoMarginBottom: true
        })
      })
    }), /*#__PURE__*/_jsxs(HStack, {
      expanded: false,
      spacing: 1,
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: () => onChangeView({
          ...view,
          page: currentPage - 1
        }),
        disabled: currentPage === 1,
        accessibleWhenDisabled: true,
        label: __('Previous page'),
        icon: chevronLeft,
        showTooltip: true,
        size: "compact",
        tooltipPosition: "top"
      }), /*#__PURE__*/_jsx(Button, {
        onClick: () => onChangeView({
          ...view,
          page: currentPage + 1
        }),
        disabled: currentPage >= totalPages,
        accessibleWhenDisabled: true,
        label: __('Next page'),
        icon: chevronRight,
        showTooltip: true,
        size: "compact",
        tooltipPosition: "top"
      })]
    })]
  });
});
export default Pagination;
//# sourceMappingURL=pagination.js.map